import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import intl from "react-intl-universal";
import { direct, style } from "../../utils/image";
import ReactSVG from "react-svg";
import moment from "moment";
import "rc-slider/assets/index.css";

import "./PosterPortal.scss";
import PosterBottom from "./Poster/PosterBottom";
import { toJpeg } from "html-to-image";
import useSavePoster from "./Poster/useSavePoster";
import { TemplateComponent } from "./Poster/PosterTemplate";
import { observer, inject } from "mobx-react";
import RootStore from "../../store/RootStore";
import useBodyScrollLock from "../Common/useBodyScrollLock";
import posterApi from "../../actions/poster";
import { IOneGallery } from "../GalleryList/Common";
import {getPageSameType} from '../../utils/util';

interface IPosterPortal {
  data: IOneGallery[];
  onClose: () => void;
  rootStore?: RootStore;
}

export const getActionDate = () => {
  let start = moment(window.gallery.start_time);
  let end = moment(window.gallery.end_time);
  if (start.isValid()) {
    if (end.isValid()) {
      if (start.format("YYYYMMDD") == end.format("YYYYMMDD")) {
        return start.format("YYYY.MM.DD HH:mm");
      } else {
        return start.format("YYYY.MM.DD") + "-" + end.format("MM.DD");
      }
    }
    return start.format("YYYY.MM.DD HH:mm");
  }

  return "";
};

export const DefaultTemplateId = 2;

const getPosterButtonConfig = (template: any) => {
  const pendants = getPageSameType(template, [], "pendent") || [];
  for (const pendant of pendants) {
    const button = (pendant && pendant.buttons || []).find(
      (item: any) => item && item.type == "jigsaw"
    );
    if (button) {
      return button;
    }
  }
  return null;
};

const PosterPortal = (props: IPosterPortal) => {
  const posterPortalContainer = useRef(document.createElement("div"));
  useEffect(() => {
    document.body.appendChild(posterPortalContainer.current);
    return () => {
      document.body.removeChild(posterPortalContainer.current);
    };
  }, []);

  const theOne = props.data[0]; // 只能选1个
  const theOneAlign = theOne && Number(theOne.width) > Number(theOne.height) ? 1 : 2;
  const { wxuserStore, commonStore, galleryStore, pagedataStore} = props.rootStore!;
  const [diyTemplates, setDiyTemplates] = useState([] as any);
  const [useRootLink, setUseRootLink] = useState(false);

  useEffect(()=>{
    let cancelled = false;

    const loadDiyTemplates = async () => {
      let button = getPosterButtonConfig(window.pageDetail.template);

      // 展商详情页使用独立装修模板，海报配置仍继承自父页面。
      // 当前页找不到自定义模板 ID 时，回退读取已有的父页面装修数据。
      if (
        (!button || !button.extra) &&
        (Number(window.pageDetail.parent) || window.exhibitorInfo)
      ) {
        const parentPageData: any = await pagedataStore.getParentPgData(
          window.pageDetail.link_id
        );
        const parentButton = getPosterButtonConfig(
          parentPageData && parentPageData.template
        );
        if (parentButton) {
          button = parentButton;
        }
      }

      if (cancelled) {
        return;
      }

      if(button && typeof button.useRoot != 'undefined') {
        setUseRootLink(!!button.useRoot);
      }

      if(button && button.extra) {
        const res = await galleryStore.getPosterDiyTemplate(button.extra);
        if (!cancelled && res && res.code == 200) {
          const {data} = res;
          const filterTemplate = data.map((it:any)=>{
              return {
                ...it,
                key: `template${it.id}`,
                src: style(it.icon, 'avatar_150'),
              }
            }).filter((it:any)=>{
              return it.adjust == theOneAlign;
            });
          setDiyTemplates(filterTemplate);
          if(filterTemplate && filterTemplate.length) {
            setTemplateId(filterTemplate[0].id);
          }else {
            setTemplateId(DefaultTemplateId);
          }
        }
      }else {
        setTemplateId(DefaultTemplateId);
      }
    };

    loadDiyTemplates().catch(error => {
      console.error('[PosterPortal] load diy templates failed', error);
      if (!cancelled) {
        setTemplateId(DefaultTemplateId);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  // 保存前检查是否登录
  const saveBefore = function () {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return false;
    }
    return true;
  };
  const saveCb = async function (data: string) {
    //const {openid} = wxuserStore.user;

    const fileKey = `poster/g${window.gallery.id}_t${templateId}_m${theOne.id}.jpg`;
    const upload = await commonStore.uploadImage(
      {
        // g[相册ID]_t[模板ID]_m[照片ID]
        key: fileKey,
        file: data,
      },
      "base64"
    );
    console.log(upload, "success");
    if (upload && Number(upload.status) == 200) {
      // 提交数据
      posterApi.createv2({
        galleryid: window.gallery.id,
        imageids: JSON.stringify([theOne.id]),
        thumb: fileKey,
      });
    }
  };

  const { posterMainRef, saveImg, builtDataUrl, preview, setPreview } =
    useSavePoster({ saveCb, saveBefore });

  // const [template, setTemplate] = useState("diy");
  const [templateId, setTemplateId] = useState(2); // 默认用模板1，除非有获取到DIY的东西
  // imgUrl直接缓存，避免切换template又重新去请求了图片（毕竟style方法会随机加载一个id）
  const imgUrl = useMemo(
    () => style(theOne.hash, "wx_750_n", {
      width:Number(theOne.width),
      height:Number(theOne.height),
      targetWidth:1366,
      watermark: galleryStore.getWatermarksByKey(theOne.galleryid,
        typeof theOne.show_mark != 'undefined'
          ? theOne.show_mark
          : 1
      )
    }, theOne.id),
    [theOne]
  );

  useBodyScrollLock(posterPortalContainer.current);

  const currentWidth = document.body.clientWidth;

  return createPortal(
    <div className="poster-portal">
      <div className="poster-portal-mask" />
      {preview ? (
        <div
          className="poster-portal-wrapper"
          style={{ backgroundColor: "transparent" }}
        >
          <div className={"preview-wrapper"}>
            <img src={builtDataUrl} style={{ width: "100%" }} />
            <div className="tip-wrapper">
              <div className={"tip"}>{intl.get("long-press-to-save-1")}</div>
            </div>

            <div
              className="poster-portal-close"
              onClick={() => setPreview(false)}
            >
              <ReactSVG
                src={require("../../svg/x.svg")}
                className="x"
                style={{ fill: "#fff", width: "14px" }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="poster-portal-wrapper">
          <div style={{ zoom: currentWidth / 750, flex: 1, overflowY: "auto" }}>
            {templateId >= 0 ? <TemplateComponent
              templateId={templateId}
              img={imgUrl}
              source={templateId >= 1000 ? diyTemplates.find((it:any)=>it.id == templateId) : null}
              ref={posterMainRef}
              useRoot={useRootLink}
            /> : null}
          </div>
          <PosterBottom
            diyTemplates={diyTemplates}
            saveImg={saveImg}
            templateId={templateId}
            setTemplateId={setTemplateId}
          />

          <div className="poster-portal-close" onClick={props.onClose}>
            <ReactSVG
              src={require("../../svg/x.svg")}
              className="x"
              style={{ fill: "#fff", width: "14px" }}
            />
          </div>
        </div>
      )}
    </div>,
    posterPortalContainer.current
  );
};

export default inject("rootStore")(observer(PosterPortal));
